import request from '@/utils/request'
// import store from '../store'

// 获取省市区地址信息
export function getRegionInfo (id) {
  return request({
    url: '/ordering_system_mobile/globalregioninfo/regionInfo',
    method: 'post',
    data: {
      parentId: id
    }
  })
}

// 获取地址列表
export function getUserAddress (id) {
  return request({
    url: '/ordering_system_mobile/useraddress/getUserAddress',
    method: 'post',
    data: {
      userId: id
    }
  })
}

// 更新或添加收货地址
export function saveUserAddress (data) {
  return request({
    url: '/ordering_system_mobile/useraddress/saveUserAddress',
    method: 'post',
    data: {
      ...data
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/address.js